import React from "react";
import "./loading.sass";

export default function Loading() {
  return (
    <div className="loading">
      <div className="container-loading">
        <div className="loadingIndicator"></div>
      </div>
    </div>
  );
}
